import React from 'react';
import TextWithImageFullscreen from '../TextWithImage/Fullscreen';

const ParagraphIndexSummary = ({ entity }) => {
  return (
    <TextWithImageFullscreen
      className="ParagraphIndexSummary"
      entity={entity}
      hasSummaryLinks
    />
  );
};

export default ParagraphIndexSummary;
